module.exports = __webpack_public_path__ + "static/media/IMG_3374.651c7398.JPG";